import { useEffect, useState } from 'react'
import { SCREEN_TABLET } from 'app-constants'

export function useMobile() {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth < SCREEN_TABLET)
    }

    window.onresize = handleResize
    setIsMobile(window.innerWidth < SCREEN_TABLET)
  }, [])

  return {
    isMobile,
  }
}
